import React from 'react'

const DashboardLoader = () => {
    return (
        <>
            <div id="page">
                <div id="container">
                    <div id="ring"></div>
                    <div id="ring"></div>
                    <div id="ring"></div>
                    <div id="ring"></div>
                    <div id="h1" className='text-xl font-bold'>Loading...</div>
                </div>
            </div>


        </>

    )
}

export default DashboardLoader